import { render } from "./ExhibitorCard.vue?vue&type=template&id=3e0e89d3&scoped=true"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js"

import "./ExhibitorCard.vue?vue&type=style&index=0&id=3e0e89d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0e89d3"]])

export default __exports__